import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import {CookiesProvider} from "react-cookie";
import GuessGhost from "./components/GuessGhost";
import GuessRoom from "./components/GuessRoom";
import LoginForm from './components/LoginForm';
import MainLayout from './components/MainLayout';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import ErrorPage from './components/ErrorPage';
import NotFoundPage from './components/NotFoundPage';
import VerifyPage from './components/VerifyPage';



const router = createBrowserRouter([
  {
    element: <MainLayout/>,
    children: [
      {
        path: "/",
        element: <App/>,
        errorElement: <ErrorPage/>
      },
      { 
        path: "/ghost",
        element: <GuessGhost />,
        errorElement: <ErrorPage/>
      },
      {
        path:"/room",
        element: <GuessRoom />,
        errorElement: <ErrorPage/>
      },
      {
        path: "/verify/:token",
        element: <VerifyPage />,
        errorElement: <ErrorPage />
      },
      {
        path: "*",
        element: <NotFoundPage />,
        errorElement: <ErrorPage />
      }
    ]
  }
])

function Router(){
  useEffect(() => {
    const onUnauthorized = () => {
      toast.error("Session expired, please log in again if you have an account or continue as guest");
    };

    const onServerError = () => {
      toast.error("Server error, please try again later");
    };

    const onNetworkError = () => {
      toast.error("Connection error, please check your internet connection");
    };

    window.addEventListener("unauthorized", onUnauthorized);
    window.addEventListener("serverError", onServerError);
    window.addEventListener("networkError", onNetworkError);
    window.addEventListener("rateLimitError", () => {
      toast.error("Too many requests, please try again later");
    });

    return () => {
      window.removeEventListener("unauthorized", onUnauthorized);
      window.removeEventListener("serverError", onServerError);
      window.removeEventListener("networkError", onNetworkError);
      window.removeEventListener("rateLimitError", () => {
        toast.error("Too many requests, please try again later");
      });
    };
  }, []);
  return(
    <CookiesProvider>
      <AuthProvider>
        <RouterProvider router={router}/>
      </AuthProvider>
    </CookiesProvider>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Router/>
      <ToastContainer 
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          toastClassName="custom-toast"
        />
    </ErrorBoundary>
  </React.StrictMode>
);
reportWebVitals();
